// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Transactions_main__0eWYA {
  display: grid;
  grid-template-columns: 72rem 1fr;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  gap: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Transactions_main__0eWYA {
    grid-template-columns: 56rem 1fr;
  }
}
@media only screen and (max-width: 43.75em) {
  .Transactions_main__0eWYA {
    grid-template-columns: 100%;
  }
}
.Transactions_main_nav__TRDxv {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 2rem;
  padding: 0 2rem;
  background-color: var(--color-white);
  border-bottom: solid 1px var(--color-dark);
  border-radius: 1rem 1rem 0 0;
}
.Transactions_main_nav__TRDxv > :not(:last-child) {
  margin-right: 1rem;
}
.Transactions_main_nav_group__8Po1l {
  position: relative;
}
.Transactions_main_nav_more__HXbHd {
  position: absolute;
  right: 0;
  top: 75%;
  background-color: var(--color-white);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  z-index: 5;
}
.Transactions_main_nav_more__HXbHd > :not(last-child) {
  margin-bottom: 1rem;
}
.Transactions_main_nav_item__C7pbQ {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
}
.Transactions_main_nav_item_active__VecMV {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  font-weight: 700;
  color: var(--color-primary);
  border-bottom: solid 2px var(--color-primary);
}
.Transactions_main_nav_item__C7pbQ:hover, .Transactions_main_nav_item__C7pbQ:focus, .Transactions_main_nav_item__C7pbQ:focus-visible, .Transactions_main_nav_item__C7pbQ:focus-within {
  font-weight: 700;
  color: var(--color-primary);
  border-bottom: solid 2px var(--color-primary);
}

.Transactions_searchInMiddle__c6yJF {
  margin-top: 3rem;
  grid-column: 1/3;
  display: flex;
  width: 100%;
  justify-content: center;
}

.Transactions_recent__\\+uJUo {
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  grid-column: 1/3;
  margin-top: 3rem;
}
.Transactions_recent__title__tWoPF {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
  border-radius: 1rem;
  background-color: var(--color-primary-3);
  font-size: var(--default-font-small);
}
.Transactions_recent__title__active__WW6pA {
  background-color: var(--color-dark);
  color: var(--color-white);
  font-weight: 700;
}
.Transactions_recent__title__tWoPF > * {
  padding: 1rem 0;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
}
@media only screen and (max-width: 37.5em) {
  .Transactions_recent__title__tWoPF > * {
    text-align: center;
    padding: 1rem;
  }
}
.Transactions_recent__title__tWoPF > *:hover {
  background-color: var(--color-dark);
  color: var(--color-white);
  font-weight: 700;
}
.Transactions_recent__title__tWoPF > :not(:last-child) {
  border-right: 1px solid var(--color-primary);
}
.Transactions_recent__title__tWoPF > :first-child {
  border-radius: 1rem 0 0 1rem;
}
.Transactions_recent__title__tWoPF > :last-child {
  border-radius: 0 1rem 1rem 0;
}

.Transactions_date__AR2ZR {
  background: var(--color-dark);
  border-radius: 1rem;
  padding: 1rem;
  text-align: center;
  font-weight: 700;
  font-size: var(--default-font-small);
  line-height: 1.7rem;
  color: var(--color-white);
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.Transactions_rt__main__8h1hC {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.Transactions_rt__content__OylBj {
  width: 95%;
  cursor: pointer;
}
.Transactions_rt__content__OylBj > :not(:last-child) {
  margin-bottom: 3rem;
}

.Transactions_paymentType__konyh {
  display: flex;
  flex-direction: row;
  gap: 2.9rem;
  margin-right: 2rem;
  margin-bottom: 2rem;
}

.Transactions_beside__sh6vD {
  display: flex;
  justify-content: space-between;
  width: 38rem;
}

.Transactions_successImg__ksTU1 {
  height: 19rem;
}

.Transactions_error__NPbqG {
  font-size: var(--default-font-small);
  color: var(--color-error);
  font-weight: 400;
}

.Transactions_checks__mnsLT {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
  gap: 7rem;
  width: 40rem;
}

.Transactions_incomeTable__kJPzn {
  margin-top: 2rem;
}
.Transactions_incomeTable__kJPzn table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font-small);
}
.Transactions_incomeTable__kJPzn table th,
.Transactions_incomeTable__kJPzn table td {
  padding: 2.2rem 0;
}
.Transactions_incomeTable__kJPzn table th {
  font-weight: 700;
}
.Transactions_incomeTable__kJPzn table tr {
  display: grid;
  grid-template-columns: 1fr 2.5fr repeat(4, 1fr) 0.5fr;
  padding: 0 1.5rem;
}
@media only screen and (max-width: 37.5em) {
  .Transactions_incomeTable__kJPzn table tr {
    grid-template-columns: 1.5fr 2.5fr 1fr;
  }
}
.Transactions_incomeTable__kJPzn table tbody > :not(:last-child) {
  margin-bottom: 1.5rem;
}
.Transactions_incomeTable__kJPzn table tbody tr {
  background-color: var(--color-primary-3);
  cursor: pointer;
  border-radius: 1.3rem;
}
.Transactions_incomeTable__kJPzn table tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
}
.Transactions_incomeTable__kJPzn table tbody tr > :nth-child(7) {
  font-size: 3rem;
  position: relative;
}
.Transactions_incomeTable__kJPzn table tbody tr > :nth-child(7) span {
  font-size: 1.2rem;
  width: fit-content;
  background-color: rgba(0, 0, 0, 0.75);
  color: var(--color-white);
  position: absolute;
  padding: 0.5rem;
  left: -1.6rem;
  border-radius: 0.5rem;
  text-align: center;
  opacity: 0;
  cursor: pointer;
}
.Transactions_incomeTable__kJPzn table tbody tr > :nth-child(7) span:hover {
  opacity: 1;
}

.Transactions_expenseTable__EvhQv {
  margin-top: 2rem;
}
.Transactions_expenseTable__EvhQv table {
  width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font-small);
}
.Transactions_expenseTable__EvhQv table th,
.Transactions_expenseTable__EvhQv table td {
  padding: 2.2rem 0;
}
.Transactions_expenseTable__EvhQv table th {
  font-weight: 700;
}
.Transactions_expenseTable__EvhQv table tr {
  display: grid;
  grid-template-columns: repeat(6, 1fr) 0.5fr;
  padding: 0 3rem;
}
@media only screen and (max-width: 37.5em) {
  .Transactions_expenseTable__EvhQv table tr {
    grid-template-columns: 1.5fr 2fr 2fr;
  }
}
.Transactions_expenseTable__EvhQv table tbody > :not(:last-child) {
  margin-bottom: 1.5rem;
}
.Transactions_expenseTable__EvhQv table tbody tr {
  background-color: var(--color-primary-3);
  cursor: pointer;
  border-radius: 1.3rem;
}
.Transactions_expenseTable__EvhQv table tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
}
.Transactions_expenseTable__EvhQv table tbody tr > :nth-child(7) {
  font-size: 3rem;
  position: relative;
}
.Transactions_expenseTable__EvhQv table tbody tr > :nth-child(7) span {
  font-size: 1.2rem;
  width: fit-content;
  background-color: rgba(0, 0, 0, 0.75);
  color: var(--color-white);
  position: absolute;
  padding: 0.5rem;
  left: -1.6rem;
  border-radius: 0.5rem;
  text-align: center;
  opacity: 0;
  cursor: pointer;
}
.Transactions_expenseTable__EvhQv table tbody tr > :nth-child(7) span:hover {
  opacity: 1;
}

.Transactions_expenseDebtTable__d08Tl {
  margin-top: 2rem;
}
.Transactions_expenseDebtTable__d08Tl table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font-small);
  position: relative;
}
.Transactions_expenseDebtTable__d08Tl table th,
.Transactions_expenseDebtTable__d08Tl table td {
  padding: 2.2rem 0;
}
.Transactions_expenseDebtTable__d08Tl table th {
  font-weight: 700;
}
.Transactions_expenseDebtTable__d08Tl table tr {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding: 0 3rem;
  align-items: center;
}
.Transactions_expenseDebtTable__d08Tl table tbody > :not(:last-child) {
  margin-bottom: 1.5rem;
}
.Transactions_expenseDebtTable__d08Tl table tbody tr {
  background-color: var(--color-primary-3);
  cursor: pointer;
  border-radius: 1.3rem;
}
.Transactions_expenseDebtTable__d08Tl table tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
}

.Transactions_notPaid__h3MB5 {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-error);
  color: var(--color-white);
  margin: 1.5rem 0;
  width: 83%;
  text-align: center;
  padding: 1rem;
}

.Transactions_partPaid__YM64h {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-yellow);
  color: var(--color-dark);
  margin: 1.5rem 0;
  width: 83%;
  text-align: center;
  padding: 1rem;
}

.Transactions_paid__blUp\\+ {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-green);
  color: var(--color-white);
  margin-bottom: 2rem;
  width: 83%;
  position: relative;
  top: 1rem;
  padding: 1rem;
}

.Transactions_alignRight__kx--b {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  font-size: var(--default-font-small);
  color: var(--color-primary);
  cursor: pointer;
  font-weight: 700;
  text-decoration: underline;
}

.Transactions_tableButton__J36rR {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--color-white);
  font-size: 2rem;
  width: 34rem;
  height: 5.7rem;
  padding: 2rem;
  background-color: var(--color-primary);
  border-radius: 1rem;
  cursor: pointer;
  z-index: 1000;
}
.Transactions_tableButton_active__M1PO2 {
  transform: rotate(180deg);
  z-index: 10000;
}

.Transactions_dropDown__\\+ng9P {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: var(--color-white);
  font-size: 2rem;
  box-sizing: border-box;
  border-bottom: 1px solid var(--color-dark);
  padding: 1rem;
  width: 34rem;
  cursor: pointer;
  align-content: center;
}

.Transactions_receipt__list__T8YNV {
  margin-top: 2rem;
  display: flex;
  position: relative;
}
.Transactions_receipt__beside__VQWSk {
  display: flex;
  justify-content: space-between;
}
.Transactions_receipt__checks__a\\+nVp {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
}

.Transactions_summary__lIo7k {
  width: 42rem;
  margin-top: 2rem;
}
.Transactions_summary__title__xIQc2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Transactions_summary__edit__8Eugp {
  display: flex;
  align-items: flex-end;
  color: var(--color-dark);
  font-size: var(--default-font-small);
  cursor: pointer;
}
.Transactions_summary__edit__8Eugp > :last-child {
  font-size: 3rem;
  color: var(--color-primary);
}
.Transactions_summary__edit__8Eugp:hover, .Transactions_summary__edit__8Eugp:focus {
  color: var(--color-primary-4);
  font-weight: 700;
}
.Transactions_summary__line__Xjekf {
  border-top: 1px solid var(--color-primary);
  margin: 2rem 0;
}
.Transactions_summary__beside__9W2l6 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Transactions_summary__dates__QsV7m {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}
.Transactions_summary__dates__QsV7m > :not(:last-child) {
  margin-right: 2rem;
}
.Transactions_summary__details__tthZ8 {
  color: var(--color-primary);
}
.Transactions_summary__total__NeHCw {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 2rem;
  margin-bottom: 1rem;
}
.Transactions_summary__account__vGqGS {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 1rem;
  margin: 2rem 0;
}
.Transactions_summary__button__fcWZo {
  display: flex;
  gap: 2rem;
}

.Transactions_noRecord__5mGZ6 {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 75.5%;
  text-align: center;
}

.Transactions_txFilterSection__d2D-E {
  display: flex;
  gap: 2rem;
  margin-top: 2rem;
}

.Transactions_txSelect__GjgEc {
  width: 30rem;
  font-size: var(--default-font-small);
}
.Transactions_txSelect__title__JV8pz {
  width: 100%;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.9rem 2.2rem;
  background-color: var(--color-white);
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  color: var(--color-primary);
}
.Transactions_txSelect__title__JV8pz:hover {
  color: var(--color-primary-4);
  background-color: var(--color-light-blue-2);
}
.Transactions_txSelect__title__icon__8P97\\+ {
  font-size: 2rem;
}
.Transactions_txSelect__content__Hx1rY {
  width: 100%;
  background-color: var(--color-white);
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  padding: 0.9rem 0;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  max-height: 20rem;
  overflow-y: scroll;
}
.Transactions_txSelect__content__Hx1rY span {
  padding: 1rem 2.2rem;
}
.Transactions_txSelect__content__Hx1rY span:hover, .Transactions_txSelect__content__Hx1rY span:active, .Transactions_txSelect__content__Hx1rY span:focus {
  background-color: var(--color-light-blue-2);
  color: var(--color-primary);
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Transactions/Transactions.module.scss"],"names":[],"mappings":"AAGA;EACC,aAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,SAAA;AAFD;AAKC;EATD;IAUE,gCAAA;EAFA;AACF;AAIC;EAbD;IAcE,2BAAA;EADA;AACF;AAGC;EACC,aAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EAEA,oCAAA;EACA,0CAAA;EACA,4BAAA;AAFF;AAIE;EACC,kBAAA;AAFH;AAKE;EACC,kBAAA;AAHH;AAME;EACC,kBAAA;EACA,QAAA;EACA,QAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,UAAA;AAJH;AAMG;EACC,mBAAA;AAJJ;AAQE;EACC,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;AANH;AAYG;EACC,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;EACA,gBAAA;EACA,2BAAA;EACA,6CAAA;AAVJ;AAaG;EAIC,gBAAA;EACA,2BAAA;EACA,6CAAA;AAdJ;;AAyBA;EACC,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;AAtBD;;AA2BA;EACC,aAAA;EACA,0BAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAxBD;AA0BC;EACC,aAAA;EACA,WAAA;EACA,qCAAA;EACA,mBAAA;EACA,wCAAA;EACA,oCAAA;AAxBF;AA0BE;EACC,mCAAA;EACA,yBAAA;EACA,gBAAA;AAxBH;AA2BE;EACC,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAzBH;AA2BG;EAND;IAOE,kBAAA;IACA,aAAA;EAxBF;AACF;AA0BG;EACC,mCAAA;EACA,yBAAA;EACA,gBAAA;AAxBJ;AA4BE;EACC,4CAAA;AA1BH;AA6BE;EACC,4BAAA;AA3BH;AA8BE;EACC,4BAAA;AA5BH;;AAmCA;EACC,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,oCAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAhCD;;AAsCC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AAnCF;AAsCC;EACC,UAAA;EACA,eAAA;AApCF;AAsCE;EACC,mBAAA;AApCH;;AA2CA;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAxCD;;AA2CA;EACC,aAAA;EACA,8BAAA;EACA,YAAA;AAxCD;;AA2CA;EACC,aAAA;AAxCD;;AA6CA;EACC,oCAAA;EACA,yBAAA;EACA,gBAAA;AA1CD;;AA6CA;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,SAAA;EACA,YAAA;AA1CD;;AAiDA;EACC,gBAAA;AA9CD;AAgDC;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;AA9CF;AAgDE;;EAEC,iBAAA;AA9CH;AAiDE;EACC,gBAAA;AA/CH;AAkDE;EACC,aAAA;EACA,qDAAA;EACA,iBAAA;AAhDH;AAkDG;EALD;IAME,sCAAA;EA/CF;AACF;AAmDG;EACC,qBAAA;AAjDJ;AAoDG;EACC,wCAAA;EACA,eAAA;EACA,qBAAA;AAlDJ;AAoDI;EACC,wCAAA;AAlDL;AAqDI;EACC,eAAA;EACA,kBAAA;AAnDL;AAqDK;EACC,iBAAA;EACA,kBAAA;EACA,qCAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AAnDN;AAqDM;EACC,UAAA;AAnDP;;AA4DA;EACC,gBAAA;AAzDD;AA2DC;EACC,WAAA;EAEA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;AA1DF;AA4DE;;EAEC,iBAAA;AA1DH;AA6DE;EACC,gBAAA;AA3DH;AA8DE;EACC,aAAA;EACA,2CAAA;EACA,eAAA;AA5DH;AA8DG;EALD;IAME,oCAAA;EA3DF;AACF;AA+DG;EACC,qBAAA;AA7DJ;AAgEG;EACC,wCAAA;EACA,eAAA;EACA,qBAAA;AA9DJ;AAgEI;EACC,wCAAA;AA9DL;AAiEI;EACC,eAAA;EACA,kBAAA;AA/DL;AAiEK;EACC,iBAAA;EACA,kBAAA;EACA,qCAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AA/DN;AAiEM;EACC,UAAA;AA/DP;;AAwEA;EACC,gBAAA;AArED;AAuEC;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;AArEF;AAuEE;;EAEC,iBAAA;AArEH;AAwEE;EACC,gBAAA;AAtEH;AAyEE;EACC,aAAA;EACA,qCAAA;EACA,eAAA;EACA,mBAAA;AAvEH;AA2EG;EACC,qBAAA;AAzEJ;AA4EG;EACC,wCAAA;EACA,eAAA;EACA,qBAAA;AA1EJ;AA4EI;EACC,wCAAA;AA1EL;;AAiFA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;AA9ED;;AAiFA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,wBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;AA9ED;;AAiFA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;AA9ED;;AAiFA;EACC,WAAA;EACA,aAAA;EACA,yBAAA;EACA,oCAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AA9ED;;AAiFA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,sCAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;AA9ED;AAgFC;EACC,yBAAA;EACA,cAAA;AA9EF;;AAkFA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,oCAAA;EACA,eAAA;EACA,sBAAA;EACA,0CAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;AA/ED;;AAmFC;EACC,gBAAA;EACA,aAAA;EACA,kBAAA;AAhFF;AAmFC;EACC,aAAA;EACA,8BAAA;AAjFF;AAoFC;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;AAlFF;;AAsFA;EACC,YAAA;EACA,gBAAA;AAnFD;AAqFC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAnFF;AAsFC;EACC,aAAA;EACA,qBAAA;EACA,wBAAA;EACA,oCAAA;EACA,eAAA;AApFF;AAsFE;EACC,eAAA;EACA,2BAAA;AApFH;AAuFE;EAEC,6BAAA;EACA,gBAAA;AAtFH;AA0FC;EACC,0CAAA;EACA,cAAA;AAxFF;AA2FC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAzFF;AA4FC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AA1FF;AA4FE;EACC,kBAAA;AA1FH;AA8FC;EACC,2BAAA;AA5FF;AA+FC;EACC,aAAA;EACA,gCAAA;EACA,SAAA;EACA,mBAAA;AA7FF;AAgGC;EACC,aAAA;EACA,gCAAA;EACA,SAAA;EACA,cAAA;AA9FF;AAiGC;EACC,aAAA;EACA,SAAA;AA/FF;;AAmGA;EACC,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAhGD;;AAuGA;EACC,aAAA;EACA,SAAA;EACA,gBAAA;AApGD;;AAuGA;EACC,YAAA;EACA,oCAAA;AApGD;AAsGC;EACC,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,oCAAA;EACA,mBAAA;EACA,4CAAA;EACA,eAAA;EACA,2BAAA;AApGF;AAsGE;EACC,6BAAA;EACA,2CAAA;AApGH;AAwGE;EACC,eAAA;AAtGH;AA4GC;EACC,WAAA;EACA,oCAAA;EACA,mBAAA;EACA,4CAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AA1GF;AA4GE;EACC,oBAAA;AA1GH;AA4GG;EAGC,2CAAA;EACA,2BAAA;EACA,gBAAA;AA5GJ","sourcesContent":["// styles for BusinessInsightCards and QuickCards//\n@import '../variables/breakpoints';\n\n.main {\n\tdisplay: grid;\n\tgrid-template-columns: 72rem 1fr;\n\talign-items: center;\n\twidth: 100%;\n\tbox-sizing: border-box;\n\tgap: 2rem;\n\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\tgrid-template-columns: 56rem 1fr;\n\t}\n\n\t@media only screen and (max-width: $bp-700) {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t&_nav {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tflex-wrap: wrap;\n\t\tmargin-top: 2rem;\n\t\tpadding: 0 2rem;\n\t\t// border-top: solid 1px var(--color-primary);\n\t\tbackground-color: var(--color-white);\n\t\tborder-bottom: solid 1px var(--color-dark);\n\t\tborder-radius: 1rem 1rem 0 0;\n\n\t\t&> :not(:last-child) {\n\t\t\tmargin-right: 1rem;\n\t\t}\n\n\t\t&_group {\n\t\t\tposition: relative;\n\t\t}\n\n\t\t&_more {\n\t\t\tposition: absolute;\n\t\t\tright: 0;\n\t\t\ttop: 75%;\n\t\t\tbackground-color: var(--color-white);\n\t\t\tpadding: 1.5rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\t\tz-index: 5;\n\n\t\t\t&> :not(last-child) {\n\t\t\t\tmargin-bottom: 1rem;\n\t\t\t}\n\t\t}\n\n\t\t&_item {\n\t\t\tcursor: pointer;\n\t\t\tpadding: 1rem 0;\n\t\t\tbox-sizing: border-box;\n\t\t\tfont-size: var(--default-font-small);\n\n\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t// \twidth: 47%;\n\t\t\t// }\n\n\t\t\t&_active {\n\t\t\t\tcursor: pointer;\n\t\t\t\tpadding: 1rem 0;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\tfont-size: var(--default-font-small);\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tborder-bottom: solid 2px var(--color-primary);\n\t\t\t}\n\n\t\t\t&:hover,\n\t\t\t&:focus,\n\t\t\t&:focus-visible,\n\t\t\t&:focus-within {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tborder-bottom: solid 2px var(--color-primary);\n\t\t\t}\n\t\t}\n\t}\n\n\t// & > :nth-child(3) {\n\t// \tgrid-column: 1/3;\n\t// \tgrid-row: 2/3;\n\t// }\n}\n\n.searchInMiddle {\n\tmargin-top: 3rem;\n\tgrid-column: 1/3;\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: center;\n}\n\n// styles for recent transactions //\n\n.recent {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr;\n\twidth: 100%;\n\tgrid-column: 1/3;\n\tmargin-top: 3rem;\n\n\t&__title {\n\t\tdisplay: grid;\n\t\twidth: 100%;\n\t\tgrid-template-columns: repeat(3, 1fr);\n\t\tborder-radius: 1rem;\n\t\tbackground-color: var(--color-primary-3);\n\t\tfont-size: var(--default-font-small);\n\n\t\t&__active {\n\t\t\tbackground-color: var(--color-dark);\n\t\t\tcolor: var(--color-white);\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\t&>* {\n\t\t\tpadding: 1rem 0;\n\t\t\ttext-align: center;\n\t\t\tbox-sizing: border-box;\n\t\t\tcursor: pointer;\n\n\t\t\t@media only screen and (max-width: $bp-600) {\n\t\t\t\ttext-align: center;\n\t\t\t\tpadding: 1rem;\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--color-dark);\n\t\t\t\tcolor: var(--color-white);\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\n\t\t&> :not(:last-child) {\n\t\t\tborder-right: 1px solid var(--color-primary);\n\t\t}\n\n\t\t&> :first-child {\n\t\t\tborder-radius: 1rem 0 0 1rem;\n\t\t}\n\n\t\t&> :last-child {\n\t\t\tborder-radius: 0 1rem 1rem 0;\n\t\t}\n\t}\n}\n\n// Transaction Date //\n\n.date {\n\tbackground: var(--color-dark);\n\tborder-radius: 1rem;\n\tpadding: 1rem;\n\ttext-align: center;\n\tfont-weight: 700;\n\tfont-size: var(--default-font-small);\n\tline-height: 1.7rem;\n\tcolor: var(--color-white);\n\tmargin-top: 2rem;\n\tmargin-bottom: 2rem;\n}\n\n// Recent Transactions //\n\n.rt {\n\t&__main {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n\n\t&__content {\n\t\twidth: 95%;\n\t\tcursor: pointer;\n\n\t\t&> :not(:last-child) {\n\t\t\tmargin-bottom: 3rem;\n\t\t}\n\t}\n}\n\n// Add Payment Type Styles //\n\n.paymentType {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 2.9rem;\n\tmargin-right: 2rem;\n\tmargin-bottom: 2rem;\n}\n\n.beside {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\twidth: 38rem;\n}\n\n.successImg {\n\theight: 19rem;\n}\n\n//Errors\n\n.error {\n\tfont-size: var(--default-font-small);\n\tcolor: var(--color-error);\n\tfont-weight: 400;\n}\n\n.checks {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin: 1rem 0 2rem 0;\n\tgap: 7rem;\n\twidth: 40rem;\n\n\t// &> :not(:last-child) {\n\t// \tmargin-right: 1rem;\n\t// }\n}\n\n.incomeTable {\n\tmargin-top: 2rem;\n\n\ttable {\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t\tborder: none;\n\t\tborder-collapse: collapse;\n\t\tbox-sizing: border-box;\n\t\ttext-align: left;\n\t\tfont-size: var(--default-font-small);\n\n\t\tth,\n\t\ttd {\n\t\t\tpadding: 2.2rem 0;\n\t\t}\n\n\t\tth {\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\ttr {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: 1fr 2.5fr repeat(4, 1fr) 0.5fr;\n\t\t\tpadding: 0 1.5rem;\n\n\t\t\t@media only screen and (max-width: $bp-600) {\n\t\t\t\tgrid-template-columns: 1.5fr 2.5fr 1fr;\n\t\t\t}\n\t\t}\n\n\t\ttbody {\n\t\t\t&> :not(:last-child) {\n\t\t\t\tmargin-bottom: 1.5rem;\n\t\t\t}\n\n\t\t\ttr {\n\t\t\t\tbackground-color: var(--color-primary-3);\n\t\t\t\tcursor: pointer;\n\t\t\t\tborder-radius: 1.3rem;\n\n\t\t\t\t&:nth-child(even) {\n\t\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\t}\n\n\t\t\t\t&> :nth-child(7) {\n\t\t\t\t\tfont-size: 3rem;\n\t\t\t\t\tposition: relative;\n\n\t\t\t\t\tspan {\n\t\t\t\t\t\tfont-size: 1.2rem;\n\t\t\t\t\t\twidth: fit-content;\n\t\t\t\t\t\tbackground-color: rgba(0, 0, 0, 0.75);\n\t\t\t\t\t\tcolor: var(--color-white);\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tpadding: 0.5rem;\n\t\t\t\t\t\tleft: -1.6rem;\n\t\t\t\t\t\tborder-radius: 0.5rem;\n\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\topacity: 0;\n\t\t\t\t\t\tcursor: pointer;\n\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.expenseTable {\n\tmargin-top: 2rem;\n\n\ttable {\n\t\twidth: 100%;\n\t\t// max-width: 100%;\n\t\tborder: none;\n\t\tborder-collapse: collapse;\n\t\tbox-sizing: border-box;\n\t\ttext-align: left;\n\t\tfont-size: var(--default-font-small);\n\n\t\tth,\n\t\ttd {\n\t\t\tpadding: 2.2rem 0;\n\t\t}\n\n\t\tth {\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\ttr {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: repeat(6, 1fr) 0.5fr;\n\t\t\tpadding: 0 3rem;\n\n\t\t\t@media only screen and (max-width: $bp-600) {\n\t\t\t\tgrid-template-columns: 1.5fr 2fr 2fr;\n\t\t\t}\n\t\t}\n\n\t\ttbody {\n\t\t\t&> :not(:last-child) {\n\t\t\t\tmargin-bottom: 1.5rem;\n\t\t\t}\n\n\t\t\ttr {\n\t\t\t\tbackground-color: var(--color-primary-3);\n\t\t\t\tcursor: pointer;\n\t\t\t\tborder-radius: 1.3rem;\n\n\t\t\t\t&:nth-child(even) {\n\t\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\t}\n\n\t\t\t\t&> :nth-child(7) {\n\t\t\t\t\tfont-size: 3rem;\n\t\t\t\t\tposition: relative;\n\n\t\t\t\t\tspan {\n\t\t\t\t\t\tfont-size: 1.2rem;\n\t\t\t\t\t\twidth: fit-content;\n\t\t\t\t\t\tbackground-color: rgba(0, 0, 0, 0.75);\n\t\t\t\t\t\tcolor: var(--color-white);\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tpadding: 0.5rem;\n\t\t\t\t\t\tleft: -1.6rem;\n\t\t\t\t\t\tborder-radius: 0.5rem;\n\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\topacity: 0;\n\t\t\t\t\t\tcursor: pointer;\n\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.expenseDebtTable {\n\tmargin-top: 2rem;\n\n\ttable {\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t\tborder: none;\n\t\tborder-collapse: collapse;\n\t\tbox-sizing: border-box;\n\t\ttext-align: left;\n\t\tfont-size: var(--default-font-small);\n\t\tposition: relative;\n\n\t\tth,\n\t\ttd {\n\t\t\tpadding: 2.2rem 0;\n\t\t}\n\n\t\tth {\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\ttr {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: repeat(4, 1fr);\n\t\t\tpadding: 0 3rem;\n\t\t\talign-items: center;\n\t\t}\n\n\t\ttbody {\n\t\t\t&> :not(:last-child) {\n\t\t\t\tmargin-bottom: 1.5rem;\n\t\t\t}\n\n\t\t\ttr {\n\t\t\t\tbackground-color: var(--color-primary-3);\n\t\t\t\tcursor: pointer;\n\t\t\t\tborder-radius: 1.3rem;\n\n\t\t\t\t&:nth-child(even) {\n\t\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.notPaid {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-error);\n\tcolor: var(--color-white);\n\tmargin: 1.5rem 0;\n\twidth: 83%;\n\ttext-align: center;\n\tpadding: 1rem;\n}\n\n.partPaid {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-yellow);\n\tcolor: var(--color-dark);\n\tmargin: 1.5rem 0;\n\twidth: 83%;\n\ttext-align: center;\n\tpadding: 1rem;\n}\n\n.paid {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-green);\n\tcolor: var(--color-white);\n\tmargin-bottom: 2rem;\n\twidth: 83%;\n\tposition: relative;\n\ttop: 1rem;\n\tpadding: 1rem;\n}\n\n.alignRight {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tfont-size: var(--default-font-small);\n\tcolor: var(--color-primary);\n\tcursor: pointer;\n\tfont-weight: 700;\n\ttext-decoration: underline;\n}\n\n.tableButton {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tcolor: var(--color-white);\n\tfont-size: 2rem;\n\twidth: 34rem;\n\theight: 5.7rem;\n\tpadding: 2rem;\n\tbackground-color: var(--color-primary);\n\tborder-radius: 1rem;\n\tcursor: pointer;\n\tz-index: 1000;\n\n\t&_active {\n\t\ttransform: rotate(180deg);\n\t\tz-index: 10000;\n\t}\n}\n\n.dropDown {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\tbackground-color: var(--color-white);\n\tfont-size: 2rem;\n\tbox-sizing: border-box;\n\tborder-bottom: 1px solid var(--color-dark);\n\tpadding: 1rem;\n\twidth: 34rem;\n\tcursor: pointer;\n\talign-content: center;\n}\n\n.receipt {\n\t&__list {\n\t\tmargin-top: 2rem;\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t}\n\n\t&__beside {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t}\n\n\t&__checks {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin: 1rem 0 2rem 0;\n\t}\n}\n\n.summary {\n\twidth: 42rem;\n\tmargin-top: 2rem;\n\n\t&__title {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t}\n\n\t&__edit {\n\t\tdisplay: flex;\n\t\talign-items: flex-end;\n\t\tcolor: var(--color-dark);\n\t\tfont-size: var(--default-font-small);\n\t\tcursor: pointer;\n\n\t\t&> :last-child {\n\t\t\tfont-size: 3rem;\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\n\t\t&:hover,\n\t\t&:focus {\n\t\t\tcolor: var(--color-primary-4);\n\t\t\tfont-weight: 700;\n\t\t}\n\t}\n\n\t&__line {\n\t\tborder-top: 1px solid var(--color-primary);\n\t\tmargin: 2rem 0;\n\t}\n\n\t&__beside {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t}\n\n\t&__dates {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin-bottom: 2rem;\n\n\t\t&> :not(:last-child) {\n\t\t\tmargin-right: 2rem;\n\t\t}\n\t}\n\n\t&__details {\n\t\tcolor: var(--color-primary);\n\t}\n\n\t&__total {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1.3fr 1fr;\n\t\tgap: 2rem;\n\t\tmargin-bottom: 1rem;\n\t}\n\n\t&__account {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1.3fr 1fr;\n\t\tgap: 1rem;\n\t\tmargin: 2rem 0;\n\t}\n\n\t&__button {\n\t\tdisplay: flex;\n\t\tgap: 2rem;\n\t}\n}\n\n.noRecord {\n\tposition: absolute;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: 75.5%;\n\ttext-align: center;\n}\n\n\n\n//transaction new update\n\n.txFilterSection {\n\tdisplay: flex;\n\tgap: 2rem;\n\tmargin-top: 2rem;\n}\n\n.txSelect {\n\twidth: 30rem;\n\tfont-size: var(--default-font-small);\n\n\t&__title {\n\t\twidth: 100%;\n\t\tfont-weight: 700;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tpadding: 0.9rem 2.2rem;\n\t\tbackground-color: var(--color-white);\n\t\tborder-radius: 1rem;\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\tcursor: pointer;\n\t\tcolor: var(--color-primary);\n\n\t\t&:hover {\n\t\t\tcolor: var(--color-primary-4);\n\t\t\tbackground-color: var(--color-light-blue-2);\n\t\t}\n\n\n\t\t&__icon {\n\t\t\tfont-size: 2rem;\n\n\t\t\t&__clicked {}\n\t\t}\n\t}\n\n\t&__content {\n\t\twidth: 100%;\n\t\tbackground-color: var(--color-white);\n\t\tborder-radius: 1rem;\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\tcursor: pointer;\n\t\tpadding: 0.9rem 0;\n\t\tmargin-top: 1rem;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tmax-height: 20rem;\n\t\toverflow-y: scroll;\n\n\t\tspan {\n\t\t\tpadding: 1rem 2.2rem;\n\n\t\t\t&:hover,\n\t\t\t&:active,\n\t\t\t&:focus {\n\t\t\t\tbackground-color: var(--color-light-blue-2);\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Transactions_main__0eWYA`,
	"main_nav": `Transactions_main_nav__TRDxv`,
	"main_nav_group": `Transactions_main_nav_group__8Po1l`,
	"main_nav_more": `Transactions_main_nav_more__HXbHd`,
	"main_nav_item": `Transactions_main_nav_item__C7pbQ`,
	"main_nav_item_active": `Transactions_main_nav_item_active__VecMV`,
	"searchInMiddle": `Transactions_searchInMiddle__c6yJF`,
	"recent": `Transactions_recent__+uJUo`,
	"recent__title": `Transactions_recent__title__tWoPF`,
	"recent__title__active": `Transactions_recent__title__active__WW6pA`,
	"date": `Transactions_date__AR2ZR`,
	"rt__main": `Transactions_rt__main__8h1hC`,
	"rt__content": `Transactions_rt__content__OylBj`,
	"paymentType": `Transactions_paymentType__konyh`,
	"beside": `Transactions_beside__sh6vD`,
	"successImg": `Transactions_successImg__ksTU1`,
	"error": `Transactions_error__NPbqG`,
	"checks": `Transactions_checks__mnsLT`,
	"incomeTable": `Transactions_incomeTable__kJPzn`,
	"expenseTable": `Transactions_expenseTable__EvhQv`,
	"expenseDebtTable": `Transactions_expenseDebtTable__d08Tl`,
	"notPaid": `Transactions_notPaid__h3MB5`,
	"partPaid": `Transactions_partPaid__YM64h`,
	"paid": `Transactions_paid__blUp+`,
	"alignRight": `Transactions_alignRight__kx--b`,
	"tableButton": `Transactions_tableButton__J36rR`,
	"tableButton_active": `Transactions_tableButton_active__M1PO2`,
	"dropDown": `Transactions_dropDown__+ng9P`,
	"receipt__list": `Transactions_receipt__list__T8YNV`,
	"receipt__beside": `Transactions_receipt__beside__VQWSk`,
	"receipt__checks": `Transactions_receipt__checks__a+nVp`,
	"summary": `Transactions_summary__lIo7k`,
	"summary__title": `Transactions_summary__title__xIQc2`,
	"summary__edit": `Transactions_summary__edit__8Eugp`,
	"summary__line": `Transactions_summary__line__Xjekf`,
	"summary__beside": `Transactions_summary__beside__9W2l6`,
	"summary__dates": `Transactions_summary__dates__QsV7m`,
	"summary__details": `Transactions_summary__details__tthZ8`,
	"summary__total": `Transactions_summary__total__NeHCw`,
	"summary__account": `Transactions_summary__account__vGqGS`,
	"summary__button": `Transactions_summary__button__fcWZo`,
	"noRecord": `Transactions_noRecord__5mGZ6`,
	"txFilterSection": `Transactions_txFilterSection__d2D-E`,
	"txSelect": `Transactions_txSelect__GjgEc`,
	"txSelect__title": `Transactions_txSelect__title__JV8pz`,
	"txSelect__title__icon": `Transactions_txSelect__title__icon__8P97+`,
	"txSelect__content": `Transactions_txSelect__content__Hx1rY`
};
export default ___CSS_LOADER_EXPORT___;
